<div class="action-list-item">
  <div class="label1">
    {{ label }}
  </div>
  <div>
    <img ngSrc="../../../../assets/img/arrow-blue.svg" height="20" width="20">
  </div>
</div>
